<template>
  <span class="sort">
    <v-icon :small="true" v-if="sortActive && sortAsc" v-on:click="move('desc')" color="rgb(0, 66, 189)">fas fa-chevron-up</v-icon>
    <v-icon :small="true" v-else-if="sortActive && sortDesc" v-on:click="move('asc')" color="rgb(0, 66, 189)">fas fa-chevron-down</v-icon>
    <v-icon :small="true" v-else v-on:click="move('asc')">fas fa-chevron-down</v-icon>
  </span>
</template>

<script>
  const querystring = require('querystring')

  export default {
    props: [
      'name'
    ],

    data () {
      return {
        searchWord: '',
        searchCategory: '',
        searchInitial: '',
        currentSort: '',
        currentOrderBy: '',
        sortAsc: false,
        sortDesc: false,
        sortActive: false
      }
    },

    methods: {
      move (orderBy) {
        if (this.sortActive) {
          if (orderBy === this.currentOrderBy) {
            return false;
          }
        }

        console.log(orderBy);

        var url = '/fintechs?sort=' + this.name + '&orderBy=' + orderBy;

        console.log(url)

        if (this.searchCategory) {
          url = url + '&category=' + this.searchCategory;
        }

        if (this.searchWord) {
          url = url + '&word=' + this.searchWord;
        }

        if (this.searchInitial) {
          url = url + '&initial=' + this.searchInitial;
        }

        location.href = url;
        return false;
      }
    },

    mounted () {
      if (location.search) {
        const search = location.search.replace('?', '')
        this.searchCategory = querystring.parse(search).category
        this.searchWord = querystring.parse(search).word
        this.searchInitial = querystring.parse(search).initial
        this.currentSort = querystring.parse(search).sort
        this.currentOrderBy = querystring.parse(search).orderBy
      }

      if (this.currentSort === this.name) {
        this.sortActive = true
      }

      if (this.currentOrderBy === 'desc') {
        this.sortDesc = true
      }

      if (this.currentOrderBy === 'asc') {
        this.sortAsc = true
      }
    }
  };
</script>

<style lang="scss">
  @import '../../sass/variables';

  .sort {
    margin-left: 5px;

  }
</style>
